import IContact from "@/interfaces/contact.interface";
import { ContactFiltersMessages } from "@/messages/contacts/contact-filters.messages";
import { ContactsTableMessages } from "@/messages/contacts/contacts-table.messages";
import { FilterAttributes, FilterType, IFilter } from "@/types/filter.types";
import { SelectData } from "@/types/form.types";

import { ContactFilterKey } from "../ContactFormPage/types";

export const CONTACTS_TABLE_COLUMNS = (messages: ContactsTableMessages) => {
  return [
    messages.nameColumn,
    messages.emailColumn,
    messages.phoneColumn,
    messages.cityColumn,
    messages.stateColumn,
    messages.consentStatusColumn,
    messages.activeColumn,
    messages.optionsColumn,
  ];
};

/** Column width percentages for tableLayout fixed (8 columns). */
export const CONTACTS_TABLE_COLUMN_WIDTHS = [
  "220px", // Nome
  "240px", // Email
  "160px", // Celular
  "190px", // Cidade
  "80px", // Estado
  "220px", // Consentimento
  "90px", // Ativo (switch)
  "70px", // Opções
];

export const initialFilterValues: IFilter<IContact>[] = [
  {
    property: "firstName",
    value: "",
    filterType: FilterType.Contains,
  },
  {
    property: "active",
    value: true,
    filterType: FilterType.Equals,
  },
];

export const FILTER_OPTIONS = (
  messages: ContactFiltersMessages
): SelectData<ContactFilterKey>[] => [
  { label: messages.allOption, value: "all" },
  { label: messages.firstNameLabel, value: "firstName" },
  { label: messages.emailLabel, value: "email" },
  { label: messages.mobilePhoneLabel, value: "mobilePhone" },
];

export const FILTER_ATTRIBUTES: Partial<Record<ContactFilterKey, FilterAttributes>> = {
  all: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "disable",
  },
  firstName: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "string",
  },
  mobilePhone: {
    defaultValue: "55",
    type: FilterType.Contains,
    valueType: "string",
  },
  email: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "string",
  },
};
